// extracted by mini-css-extract-plugin
module.exports = {"successful":"styles_successful__3Lk8h","failure":"styles_failure__3aSVo","ipInfo":"styles_ipInfo__ghF2P"};